export default __webpack_public_path__ + "static/media/about-iHunt-1.6cea08c5.jpg";